<app-disconnect-overlay></app-disconnect-overlay>
<app-mic-permission-overlay></app-mic-permission-overlay>
<app-audio-debugger></app-audio-debugger>
@if (this.botConfig) {
<div
  class="audio-bot"
  [ngClass]="[
    playService.state === 'play' ? 'speaking' : '',
    this.attService.isMuted ? 'muted' : '',
    attService.state.getValue()
  ]"
>
  @if (this.attService.state.getValue() !== 'unknown') {
  <div
    class="bot-voice-ball"
    [ngClass]="{'is-speaking':playService.state === 'play'}"
  ></div>
  <div
    class="user-voice-ball"
    [ngStyle]="{
          'transform': 'translate(-50%, -50%) scale(' + this.attService.volumeScale + ') ',
        }"
  ></div>
  @if (this.attService.state.getValue() ==='disconnected') {
  <button
    type="button"
    class="ball-text btn btn-outline-light"
    (click)="this.connectAudioCall()"
    i18n="@@connect"
  ><i
      class="ri-phone-fill"
      aria-hidden="true"
    ></i>Verbinden</button>
  }
  @if (this.attService.state.getValue() ==='connecting') {
  <span class="ball-text">
    @if (!getOverWriteText()) {
    <span
      i18n="@@connecting"
      class="text-audiobot-info"
    >connecting...</span>
    } @else {
    <span class="text-audiobot-info text-audiobot-info-overwrite">{{getOverWriteText()}}</span>
    }
    <ng-container *ngTemplateOutlet="mutedInfo"></ng-container>
  </span>
  }
  @if (this.attService.state.getValue() ==='thinking') {
  <span class="ball-text">
    @if (!getOverWriteText()) {
    <span
      i18n="@@thinking"
      class="text-audiobot-info"
    >moment</span>
    } @else {
    <span class="text-audiobot-info text-audiobot-info-overwrite">{{getOverWriteText()}}</span>
    }
  </span>
  }
  @if (this.attService.state.getValue() ==='sending') {
  <span class="ball-text">
    @if (!getOverWriteText()) {
    <span
      i18n="@@sending"
      class="text-audiobot-info"
    >sending</span>
    } @else {
    <span class="text-audiobot-info text-audiobot-info-overwrite">{{getOverWriteText()}}</span>
    }
  </span>
  }
  @if (this.playService.state !== 'play' && this.attService.state.getValue() ==='listening') {
  <span class="ball-text ">
    @if (!getOverWriteText()) {
    <span
      i18n="@@i-listen"
      class="text-audiobot-info"
    >ich höre</span>
    } @else {
    <span class="text-audiobot-info text-audiobot-info-overwrite">{{getOverWriteText()}}</span>
    }
    <ng-container *ngTemplateOutlet="mutedInfo"></ng-container>
  </span>
  }
  @if (this.attService.speakingState.getValue() || playService.state === 'play') {
  <span class="ball-text">
    @if (!getOverWriteText()) {
    <span
      i18n="@@talk-to-interrpt"
      class="text-audiobot-info"
    >zum unterbrechen reden</span>
    } @else {
    <span class="text-audiobot-info text-audiobot-info-overwrite">{{getOverWriteText()}}</span>
    }
    <ng-container *ngTemplateOutlet="mutedInfo"></ng-container>
  </span>
  }
  @if ( this.attService.state.getValue() !=='disconnected' && this.attService.state.getValue() !== 'connecting' ) {
  <div class=" row audio-btn-holder px-0 mx-0">
    <div class="col text-center">
      <button
        type="button"
        class="btn-disconnect cursor-pointer "
        aria-label="Gespräch beenden"
        i18n-aria-label="@@audio-disconnect"
        (click)="disconnectAudioCall()"
      >
        <i
          class="ri-close-line ri-2x"
          aria-hidden="true"
        ></i>
      </button>
    </div>
    <div
      id="col-btn-mute"
      class="col text-center"
    >
      <button
        type="button"
        class="btn-mute  cursor-pointer "
        [ngClass]="{'muted': this.attService.isMuted}"
        [attr.aria-label]="this.muteButtonLabel"
        (click)="attService.setMuted(!this.attService.isMuted)"
      >
        <i
          class="ri-2x"
          aria-hidden="true"
          [ngClass]="{
                'ri-mic-off-line ': this.attService.isMuted,
                'ri-mic-line': !this.attService.isMuted
              }"
        ></i>
      </button>
    </div>
  </div>
  }
  }
</div>
} @else {
<div class="d-flex h-100 w-100 align-items-center justify-content-center flex-column">
  <h1 i18n="@@bot-not-found">
    Dieser Bot ist nicht verfügbar. Er ist entweder nicht öffentlich oder existiert nicht mehr.
  </h1>
  <span i18n="@@bot-not-found-hint">
    Falls das ein Fehler ist, wende dich an den Bot-Besitzer.
  </span>
</div>
}



<ng-template #mutedInfo>
  @if (this.attService.isMuted) {
  <br><small
    class="muted-indicator"
    i18n="@@mic-muted"
  >Mic. stumm</small>
  }
</ng-template>